module.exports = __webpack_public_path__ + "img/backg.3698e551.png";